import React from "react";
import Icon from "@ant-design/icons";
import { IIconProps } from "typings/icons.types";

const CloseSvg = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.9997 10.5857L16.2427 6.34274C16.6332 5.95228 17.2663 5.95228 17.6567 6.34274C18.0472 6.73321 18.0472 7.36628 17.6567 7.75674L13.4137
      11.9997L17.6567 16.2427C18.0472 16.6332 18.0472 17.2663 17.6567 17.6567C17.2663 18.0472 16.6332 18.0472 16.2427 17.6567L11.9997 13.4137L7.75674
      17.6567C7.36628 18.0472 6.73321 18.0472 6.34274 17.6567C5.95228 17.2663 5.95228 16.6332 6.34274 16.2427L10.5857 11.9997L6.34274 7.75674C5.95228
       7.36628 5.95228 6.73321 6.34274 6.34274C6.73321 5.95228 7.36628 5.95228 7.75674 6.34274L11.9997 10.5857Z"
      fill="currentColor"
    />
  </svg>
);

const Close = (props: IIconProps) => <Icon component={CloseSvg} {...props} />;

export default Close;
